import { isNill as t } from "./index139.js";
function i(r) {
  if (t(r) || r === !1 || Array.isArray(r) && r.length === 0)
    return !0;
  switch (typeof r) {
    case "number":
      return isNaN(r) || r === 0;
    case "string":
      return r.trim() === "";
    case "object":
      return r instanceof Date ? isNaN(r.getTime()) : r instanceof RegExp ? r.source === "(?:)" : !t(r) && Object.keys(r).length === 0;
  }
  return !1;
}
export {
  i as isEmpty
};
